var option_default = {
  "option": "uEKqm",
  "user_choice": "l2-wX",
  "check": "TOctv",
  "image": "mwZWT",
  "input": "xKdXB",
  "title": "Vveew",
  "centered": "BnCfP",
  "with_result": "_0ASm-",
  "list": "Oii8b",
  "with_image": "uCGTw",
  "progress": "t7-9U",
  "progress_value": "m0xoe",
  "label": "f-ItU",
  "cta": "jd0zG",
  "adornment_icon": "_3WTAk",
  "remove": "_0wlMI",
  "removeButton": "dpx5P",
  "removeButtonIcon": "jSV-N",
  "overlay": "yKebR",
  "shown": "WqfwT",
  "dark": "tCBTz",
  "spinner": "TOPM1",
  "spin": "jArJr"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
